import { useCountry } from '@/components/Link'
import { SPLITS, useFeatureFlag } from '@/helpers/useFeatureFlag'
import useTenant from '@/hooks/useTenant'

// Flag-only context: `accountId` lets vendor/admin views target the order's account and
// `groupOrderShareVisit` admits logged-out invitees. Both go when the flag does.
// The `groupOrdering` flag key and its `groupOrderShareVisit` attribute keep the pre-rename
// spelling until PT-2267 retires the flag.
export type CateringTeamOrderFlagContext = {
  accountId?: string | number | null
  groupOrderShareVisit?: boolean
}

// The tenant's per-country setting is the go-live gate; the flag only narrows it during
// Feedr's pilot and is deleted afterwards (PT-2267).
export const useCateringTeamOrderEnabled = (
  context: CateringTeamOrderFlagContext = {},
): boolean => {
  const tenant = useTenant()
  const country = useCountry()
  const regions = tenant.features?.cateringTeamOrder?.visibility?.regions ?? []
  // Stored region case varies across tenant features; the locale country is already uppercase.
  const tenantEnabled = regions.some((region) => region.toUpperCase() === country)

  const flagEnabled = useFeatureFlag(SPLITS.CATERING_TEAM_ORDER, context)
  return tenantEnabled && flagEnabled
}
